import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
//20250602 axa inici
declare const $: any;
//20250602 axa final

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.css']
})
export class MessageModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input() title : string;
  @Input() message : string;
  @Input() id : number;
  @Output() close = new EventEmitter<any>();
  
  onClose (){
    this.close.emit(this.id);
  }
  //20250602 axa inici
  show(title: string = null, message: string = null) {
    if (title)
      this.title = title;
    if (message)
      this.message = message;
    $('#modal-message-' + this.id).modal('show');
  }
  //20250602 axa final

}

